import { render, staticRenderFns } from "./PkPayoutErrorList.vue?vue&type=template&id=da53244e&scoped=true"
import script from "./PkPayoutErrorList.vue?vue&type=script&lang=js"
export * from "./PkPayoutErrorList.vue?vue&type=script&lang=js"
import style0 from "./PkPayoutErrorList.vue?vue&type=style&index=0&id=da53244e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da53244e",
  null
  
)

export default component.exports